import { newsCategoryAdd } from "./news-category-add/news-category-add.module";
import { newsCategoryMain } from "./news-category-main/news-category-main.module";
import { newsCategoryEdit } from "./news-category-edit/news-category-edit.module";
import { newsCategoryList } from "./news-category-list/news-category-list.module";
import { NewsCategoryService } from "./news-category.service";

export const newsCategory = angular
  .module("components.news-category", [
    newsCategoryMain,
    newsCategoryAdd,
    newsCategoryEdit,
    newsCategoryList,
  ])
  .service("NewsCategoryService", NewsCategoryService).name;



// WEBPACK FOOTER //
// ./src/app/components/news-category/news-category.module.js